import { Component, Input, ViewChild, ElementRef, OnInit } from "@angular/core";
import { trimTextByWord } from "../../admin/events-screen/utils/trimTextByWord";
import { DataService } from "../../_services/data.service";
import { GlobalDataService } from "../../_services/global-data.service";
import { MultiSelectComponent } from "../../admin/components/multi-select/multi-select.component";
import { LoggerService } from "../../modules/logger/logger.service";

@Component({
  selector: "multi-select-layers",
  templateUrl: "multi-select-layers.component.html",
  styleUrls: ["multi-select-layers.component.scss"],
})
export class MultiSelectLayersComponent implements OnInit {
  @Input("displayType") public displayType: "smallHeight" | "largeHeight" =
    "largeHeight";
  @ViewChild("layerSelect") public layerSelect: MultiSelectComponent;

  public layers: any[] = [];

  constructor(
    private dataService: DataService,
    private globalDataService: GlobalDataService,
    private loggerService: LoggerService
  ) {}

  public ngOnInit() {
    this.loadLayerData().then();
  }

  public getSelectedLayer(): any[] {
    return (this.layerSelect.submit() as any).layerForm || ([] as number[]);
  }

  private async loadLayerData() {
    // @ts-ignore
    const result = await this.globalDataService.getLegacyNodeGlobalData();
    if (!result.success) {
      // @ts-ignore
      const errorMessage = (result && result.error) || "Unknown error";
      this.loggerService.error("Failed to load layer data:", errorMessage);
      return;
    }
    const serializedLayers = result.data.layers.map((layer) => {
      return { id: layer.layerId, name: layer.layerName };
    });
    this.layers = serializedLayers;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/multi-select-layers/multi-select-layers.component.ts